'use strict';

const { version: wcVersion, dependencies } = require('../package');
const wlVersion = dependencies["ax-weblib"].replace(/\~|\^/g, '');

const version = `${wcVersion}-WL-${wlVersion}`;
module.exports = version;
